import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function ChangePasswordDialog({ open, onClose }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [loading, setLoading] = useState(false);

  const close = () => { setCurrent(""); setNext(""); onClose(); };

  const save = async () => {
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/technician/password", { current_password: current, new_password: next });
      toast.success("Password changed");
      close();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Change password</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="font-semibold">Current password</Label>
            <Input data-testid="tech-current-password-input" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className="mt-1 border border-slate-200 h-11" />
          </div>
          <div>
            <Label className="font-semibold">New password</Label>
            <Input data-testid="tech-new-password-input" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1 border border-slate-200 h-11" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={loading || !current} data-testid="tech-password-save-btn" className="bg-brand hover:bg-brand-dark text-white font-bold shadow-btn">
            {loading ? "Saving…" : "Update password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
